import React from 'react';

const ManageRevenue = () => {
  return <div>Manage Revenue</div>;
};

export default ManageRevenue;
